import { postSendFaxApi } from "../../http/api/FaxAPI";

// fileのblobをbase64形式にエンコード　(blob) => Promise(ArrayBuffer)
const encodedPromise = (pdfBlob) => new Promise((resolve) => {
  const reader = new FileReader();
  reader.onload = () => {
    const offset = reader.result.indexOf(",") + 1;
    resolve(reader.result.slice(offset));
  };
  reader.readAsDataURL(pdfBlob);
});

// export const sendFax = async (faxFileUrl) => { 
//   try {

//     const faxFileRes = await fetch(faxFileUrl)
//     const faxFileBlob = await faxFileRes.blob()
//     const faxFileBase64 = await encodedPromise(faxFileBlob);

//     await postSendFaxApi({
//       "faxMailFrom" : process.env.REACT_APP_TEST_FAX_FROM,
//       "faxNumbers" : [process.env.REACT_APP_TEST_FAX_NUMBER],
//       "faxFileInfoList" : [{fileName: "市況価格表PDF.pdf", fileMimeType:"application/pdf", fileEncodedByBase64: faxFileBase64}]
//     });

//   } catch (err) {
//     console.log("Error", err);
//     throw(err)
//   }
// }

const sendFaxPropsToInfo = async (sendFaxprops) => {
  let {faxFileUrl, faxNumbers} = sendFaxprops;
  const faxFileRes = await fetch(faxFileUrl)
  const faxFileBlob = await faxFileRes.blob()
  const faxFileBase64 = await encodedPromise(faxFileBlob);

  return {
    "faxMailFrom" : "",
    "faxNumbers" : faxNumbers,
    "faxFileInfoList" : [{
      fileName: "市況価格表PDF.pdf",
      fileMimeType:"application/pdf",
      fileEncodedByBase64: faxFileBase64
    }]
  }
}


export const sendFax = async (sendFaxPropsList) => { 
  try {
    await postSendFaxApi({faxSendInfoList: await Promise.all(sendFaxPropsList.map((data) => sendFaxPropsToInfo(data)))});
  } catch (err) {
    console.log("Error", err);
    throw(err)
  }
}
